import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useState, useEffect } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";

export default function StorefrontHeader() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navClass = ({ isActive }) =>
    `story-link text-sm font-medium ${isActive ? "text-[#E53935]" : "text-[#0A0A0A]"}`;

  return (
    <header
      data-testid="storefront-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#F8F8F7]/80 backdrop-saturate-150 border-b border-black/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-[#E53935] flex items-center justify-center">
            <ShoppingBag className="w-4 h-4 text-white" strokeWidth={1.8} />
          </div>
          <span className="font-display font-black text-xl tracking-tighter">CURATED&nbsp;/&nbsp;FOUR</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/" end className={navClass} data-testid="nav-home">Home</NavLink>
          <NavLink to="/shop" className={navClass} data-testid="nav-shop">Shop All</NavLink>
          <NavLink to="/shop?platform=etsy" className={navClass} data-testid="nav-etsy">Etsy</NavLink>
          <NavLink to="/shop?platform=amazon" className={navClass} data-testid="nav-amazon">Amazon</NavLink>
          <NavLink to="/shop?platform=shopify" className={navClass} data-testid="nav-shopify">Shopify</NavLink>
          <NavLink to="/shop?platform=shopcom" className={navClass} data-testid="nav-shopcom">Shop.com</NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Link
              to="/admin"
              data-testid="admin-link"
              className="text-sm font-semibold uppercase tracking-wider px-5 py-2.5 bg-[#0A0A0A] text-white hover:bg-[#E53935] transition-colors"
            >
              Dashboard
            </Link>
          ) : (
            <Link
              to="/login"
              data-testid="login-link"
              className="text-sm font-semibold uppercase tracking-wider px-5 py-2.5 border border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors"
            >
              Sign In
            </Link>
          )}
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/10 bg-[#F8F8F7]">
          <div className="px-6 py-4 flex flex-col gap-3">
            <NavLink to="/" onClick={() => setOpen(false)} className="py-2" data-testid="m-nav-home">Home</NavLink>
            <NavLink to="/shop" onClick={() => setOpen(false)} className="py-2" data-testid="m-nav-shop">Shop All</NavLink>
            <NavLink to="/shop?platform=etsy" onClick={() => setOpen(false)} className="py-2">Etsy</NavLink>
            <NavLink to="/shop?platform=amazon" onClick={() => setOpen(false)} className="py-2">Amazon</NavLink>
            <NavLink to="/shop?platform=shopify" onClick={() => setOpen(false)} className="py-2">Shopify</NavLink>
            <NavLink to="/shop?platform=shopcom" onClick={() => setOpen(false)} className="py-2">Shop.com</NavLink>
            <Link to={user ? "/admin" : "/login"} onClick={() => setOpen(false)} className="mt-2 py-3 bg-[#0A0A0A] text-white text-center uppercase tracking-wider text-sm" data-testid="m-auth-cta">
              {user ? "Dashboard" : "Sign In"}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
